import * as React from 'react';
import { ContextMenu as BaseContextMenu } from '@base-ui-components/react/context-menu';
import { cn } from '@/shared/lib/cn';
import { Scroller } from '@/shared/ui/Scroller';
import styles from '@/shared/ui/Menu/Menu.module.css';

/**
 * shadcn-style ContextMenu (меню по правому клику) поверх Base UI.
 * Использование:
 *
 *   <ContextMenu>
 *     <ContextMenuTrigger render={<div className={...} />}>
 *       зона, реагирующая на ПКМ
 *     </ContextMenuTrigger>
 *     <ContextMenuContent>
 *       <ContextMenuItem onClick={...}>Действие</ContextMenuItem>
 *       <ContextMenuSeparator />
 *       <ContextMenuItem disabled>Недоступно</ContextMenuItem>
 *     </ContextMenuContent>
 *   </ContextMenu>
 *
 * @use меню по правому клику на области.
 */

export const ContextMenu = BaseContextMenu.Root;
export const ContextMenuTrigger = BaseContextMenu.Trigger;

export const ContextMenuContent = React.forwardRef<
  HTMLDivElement,
  React.ComponentProps<typeof BaseContextMenu.Popup>
>(function ContextMenuContent({ className, children, ...rest }, ref) {
  return (
    <BaseContextMenu.Portal>
      <BaseContextMenu.Positioner className={styles.positioner}>
        <BaseContextMenu.Popup ref={ref} className={cn(styles.popup, className)} {...rest}>
          { }
          <Scroller className={styles.scroller} viewportClassName={styles.viewport}>
            {children}
          </Scroller>
        </BaseContextMenu.Popup>
      </BaseContextMenu.Positioner>
    </BaseContextMenu.Portal>
  );
});

export const ContextMenuItem = React.forwardRef<
  HTMLDivElement,
  React.ComponentProps<typeof BaseContextMenu.Item> & { variant?: 'default' | 'danger' }
>(function ContextMenuItem({ className, variant = 'default', ...rest }, ref) {
  return (
    <BaseContextMenu.Item
      ref={ref}
      className={cn(styles.item, variant === 'danger' && styles.danger, className)}
      {...rest}
    />
  );
});

export const ContextMenuSeparator = React.forwardRef<
  HTMLDivElement,
  React.ComponentProps<typeof BaseContextMenu.Separator>
>(function ContextMenuSeparator({ className, ...rest }, ref) {
  return <BaseContextMenu.Separator ref={ref} className={cn(styles.separator, className)} {...rest} />;
});
